import { Typography } from '@/components/typography';

import styles from './InputLabel.module.css';

interface InputLabelProps {
  removeMargin?: boolean;
  required?: boolean;
  label: string | React.ReactNode;
  children?: React.ReactNode;
}

export function InputLabel({
  removeMargin = false,
  required = false,
  label,
  children
}: InputLabelProps) {
  return (
    <span data-has-margin={!removeMargin} className={styles.inputLabel} data-testid="inputLabel">
      <Typography sizes={['label']}>
        {label}

        {required && <span className={styles.inputLabelRequired}>*</span>}

        {children}
      </Typography>
    </span>
  );
}
